<div class="header-panel" data-testid="header-container">
  <div class="header-top ev-card" data-tutorial-container="search-panel">
    <div class="header-search">
      <app-search data-testid="header-search" [failedPlan]="false"></app-search>
    </div>

    @if (!widget) {
    <button type="button" class="ev-plain-button header-profile" data-testid="header-profile-btn" (click)="profileClick()">
      @if (subscriptionType()?.includes('pro.')) {
        <img class="pro-badge" src="assets/icons/default/ui/PRO_icon.svg" alt="pro" />
      }
      @if (subscriptionType()?.includes('proplus.')) {
        <img class="proplus-badge" src="assets/icons/default/ui/PROPLUS_icon.svg" alt="pro plus" />
      }
      <span class="profile-icon-wrapper">
        @if (!isAuthorized() || !avatarLink()) {
          <img class="user-icon-default" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/user_icon.svg'" alt="user icon" />
        }
        @if (isAuthorized() && avatarLink()) {
          <img class="user-icon" [src]="avatarLink()" alt="avatar" />
        }
        <img class="profile-hamburger-icon" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/profile_hamburger.svg'" alt="menu" />
      </span>
    </button>
    } @else if (widgetSettings) {
    <app-widget-settings-button class="header-settings"></app-widget-settings-button>
    }
  </div>

  @if (!widget) {
  <app-profile-dropdown class="ev-card" ownerClass="header-panel" [dropdownVisible]="dropdownVisible()" [loadingMap]="loadingMap ?? ''"
    (closeRequested)="dropdownVisible.set(false)"
    [class.dropdown-open]="dropdownVisible()"></app-profile-dropdown>
  }
</div>
